import { URLS, HTTP_METHODS, HEADERS_CONTENT_TYPE } from 'modules/api/constants';
import handleRequest from 'modules/api/common';
import { CancelFunctions } from 'components/common/types';
import { SearchConfig } from 'components/common/types/DirectSalesCampaign.types';

export const getSearchConfig = (publisherId: string, cancelFunctions: CancelFunctions): Promise<SearchConfig> => {
  const reqOptions = {
    url: URLS().USER_SEARCH_CONFIG(publisherId),
    method: HTTP_METHODS.GET,
    ignoreNotifyError: true,
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_USER_SEARCH_CONFIG');
};

export const saveSearchConfig = (
  publisherId: string,
  searchConfig: SearchConfig,
  cancelFunctions: CancelFunctions,
): Promise<void> => {
  const reqOptions = {
    url: URLS().USER_SEARCH_CONFIG(publisherId),
    method: HTTP_METHODS.POST,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
    data: searchConfig,
    ignoreNotifyError: true,
  };

  return handleRequest(reqOptions, cancelFunctions, 'UPDATE_USER_SEARCH_CONFIG');
};

export const deleteSearchConfig = (publisherId: string, cancelFunctions: CancelFunctions): Promise<void> => {
  const reqOptions = {
    url: URLS().USER_SEARCH_CONFIG(publisherId),
    method: HTTP_METHODS.DELETE,
    ignoreNotifyError: true,
  };

  return handleRequest(reqOptions, cancelFunctions, 'UPDATE_USER_SEARCH_CONFIG');
};
